import {
  RIGHTSHOLDER_ADD_SUCCESS,
  RIGHTSHOLDER_UPDATE_SUCCESS,
} from '@disco/constants/ActionTypes'
import { createReducer } from 'redux-create-reducer'
const initialState: Array<any> = []

export type RightsholderState = typeof initialState
export const rightsholderReducer = createReducer<RightsholderState, any>(
  initialState,
  {
    [RIGHTSHOLDER_ADD_SUCCESS](state, { rightsholders }) {
      return [...state, ...rightsholders]
    },
    [RIGHTSHOLDER_UPDATE_SUCCESS](state, { rightsholder }) {
      return state.map(r =>
        r.id === rightsholder.id ? { ...r, ...rightsholder } : r,
      )
    },
  },
)
